export const c_tabs_link_accent_length = {
  "name": "--pf-v6-c-tabs--link-accent--length",
  "value": "0",
  "var": "var(--pf-v6-c-tabs--link-accent--length)"
};
export default c_tabs_link_accent_length;